var inject = ['$scope', '$http']
export default class NavCtrl {

    constructor($scope, $http) {

        this.$http = $http;
        this.saving = false;
        this.isSaved = false;
        this.error = false;
        this.message = {
            phone: '',
            name: '',
            description: ''
        };
    }

    send() {
        var self = this;
        if (!this.saving && !this.isSaved) {
            self.error = false;
            this.saving = true;
            this.$http.post('/message', this.message).then(function (data) {
                console.log(data);
                self.isSaved = true;
                self.saving = false;
            }, function (error) {
                self.error = true;
                self.isSaved = false;
                self.saving = false;
            });
        }

    }
}

NavCtrl.$inject = inject;


// WEBPACK FOOTER //
// ./src/app/modules/message/MessageCtrl.js